module.exports = __webpack_public_path__ + "img/s6.d52c1b72.png";